import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import parsePhoneNumber from 'libphonenumber-js';

dayjs.extend(utc);

export default {
  data() {
    return {
      colorMap: {},
      availableColors: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#4BC0C0',
        '#F7464A',
        '#949FB1',
        '#4D5360'
      ]
    };
  },
  methods: {

    hashCode(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
      }
      return hash;
    },

    getColor(value) {
    console.log("value ==> ", value);
      const key =
        typeof value === 'string'
          ? value.toLowerCase().trim()
          : typeof value === 'number'
          ? String(value)
          : 'unknown';

      const predefinedColors = {
        'high': 'red',
        'level 2': 'orange',
        'medium': 'orange',
        'low': 'green',
        'approved': 'green',
        'pending': 'orange',
        'rejected': 'red',
        'active': 'green',
        'dormant': 'amber',
        'closed': 'grey',
        'suspended': 'red',
        'low': 'green',
        'medium': 'warning',
        'high': 'red',
        'significant': 'deep-purple',
        'no match': 'green',
        'potential match': 'warning',
        'match': 'red',
      };

      if (predefinedColors[key]) {
        return predefinedColors[key];
      }

      if (!this.colorMap[key]) {
        const hash = this.hashCode(key);
        const colorIndex = Math.abs(hash) % this.availableColors.length;
        const color = this.availableColors[colorIndex];
        this.$set(this.colorMap, key, color);
      }

      return this.colorMap[key];
    },

    asMoney(val) {
      if (val == undefined || isNaN(val)) return '$ 0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(val);
    },

    asPercent(val) {
      if (val == undefined || isNaN(val)) return '-';
      return `${parseFloat(parseFloat(val).toFixed(2))}%`;
    },

    formatDate(date, format) {
      const d = dayjs(date);
      return d.isValid() ? d.format(format) : date;
    },
    
    formatDateUTC(date, format) {
      const d = dayjs(date);
      return d.isValid() ? d.utc().format(format) : date;
    },

    asPhoneNumber(number) {
      try {
        const normalized = number.toString().trim().startsWith('+') 
          ? number.toString().trim() 
          : `+${number.toString().trim()}`;
        const phoneNumber = parsePhoneNumber(normalized);
        return phoneNumber.formatInternational();
      } catch (e) {
        return number;
      }
    },
    formatDateTime(dateTimeString, includeTime = false) {
      if (!dateTimeString) return '';
      
      const isDateOnly = (typeof dateTimeString === 'string' && 
                        (dateTimeString.includes('T00:00:00') || 
                          /^\d{4}-\d{2}-\d{2}$/.test(dateTimeString))) && 
                        !includeTime;
      
      if (isDateOnly) {
        const datePart = dateTimeString.includes('T') 
          ? dateTimeString.split('T')[0] 
          : dateTimeString;
        const [year, month, day] = datePart.split('-');
        
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        
        return date.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        });
      } else {
        const date = new Date(dateTimeString);
        const formattedDate = date.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        });
        
        return includeTime
          ? `${formattedDate} ${date.toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true
            })}`
          : formattedDate;
      }
    },

    capitalizeName(name) {
      if (!name || typeof name !== 'string') return '';
      return name
        .toLowerCase()
        .split(' ')
        .map((word) =>
          word
            .split('-')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join('-')
        )
        .join(' ');
    },

    asNumber(numberValue, decimalPlaces = 2) {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: decimalPlaces
      })
      return formatter.format(numberValue);
    },

    getTransactionTypeIcon(type) {
      switch (type?.toLowerCase()) {
        case 'deposit': return 'mdi-arrow-down-bold-circle';
        case 'withdrawal': return 'mdi-arrow-up-bold-circle';
        case 'transfer': return 'mdi-swap-horizontal-circle';
        case 'wire transfer': return 'mdi-bank-transfer';
        case 'payment': return 'mdi-credit-card';
        default: return 'mdi-currency-usd';
      }
    }
}
};
